import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  listImageDrawer: {
    "& .MuiDrawer-paperAnchorBottom": {
      backgroundColor: "inherit",
      boxShadow: "inherit",
      height: "100vh",
      "&::-webkit-scrollbar": {
        width: 0,
      },
    },
  },
  root: {
    height: "100%",
  },
  listImageWrapper: {
    width: "100%",
    background: "rgba(37, 40, 43, 0.8)",
    padding: 16,
  },
  swipeableViewWrapper: {
    height: "100%",
    width: "100%",
    background: "rgba(37, 40, 43, 0.8)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  roomImage: {
    cursor: "pointer",
  },
  viewRoomImage: {
    maxHeight: "90vh",
  },
  arrowWrapper: {
    position: "absolute",
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  icon: {
    color: "white",
    cursor: "pointer",
  },
}));

export default useStyles;
